<div class="d-md-flex align-items-baseline mb-3">
  <h3 class="mr-auto">Order: #{{ rental.rentalRequestNumber }}</h3>
  <div class="d-flex align-items-baseline mt-3 mt-md-0">
    <!-- this will be where we change status -->
    <!-- <div class="text-red call-out-text mr-auto mr-md-3">INVOICE DUE</div> -->
    <div class="text-grey supporting-text mr-3">Order Date: {{ rental.createdDateTime | date: "shortDate" }}</div>
    <common-status-label [status]="rental.status" labelStyle="status-pill"></common-status-label>
  </div>
</div>
